import { createSlice } from '@reduxjs/toolkit';

export const contributionSlice = createSlice({
    name: 'contribution',
    initialState: {
        dataToAction: { whoInvest: '', amount: '' }
    },
    reducers: {
        selectContribution: (state, { payload }) => {
            state.dataToAction = payload;
        },
        unSelectContribution: (state) => {
            state.dataToAction = { whoInvest: '', amount: '' }
        }
    }
});

export const { selectContribution, unSelectContribution } = contributionSlice.actions;